import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Grid,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import api, { investorApi, vendorApi } from "../../api/api";

const PropertyGrid = () => {
  const [legalTeam, setLegalTeam] = useState([]);
  const [rows, setRows] = useState([]);
  const [statusFilter, setStatusFilter] = useState("All");
  const [assignModalOpen, setAssignModalOpen] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [selectedTeamMember, setSelectedTeamMember] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const getProperties = async () => {
      try {
        const response = await vendorApi.getAllVendorProperties();
        const data = response.data;

        const formattedData = data.map((item) => ({
          id: item.Pid,
          projectId:item.ProjectId,
          UserName: item.UserName,
          ProjectName:item.ProjectName,
          PropertyName: item.PropertyName,
          City: item.City,
          Address: item.Address,
          SizeInSqFt: item.SizeInSqFt,
          SqFtPrice: item.SqFtPrice,
          Status: item.Status,
          PropertyPrice: item.PropertyPrice,
          NoOfPlots:item.NoOfPlots,
          IconUrl:item.IconUrl
        }));

        const statusOrder = {
          Pending: 1,
          Approved: 2,
          Inprogress: 3,
          Sold: 4,
        };

        const sortedData = formattedData.sort(
          (a, b) => statusOrder[a.Status] - statusOrder[b.Status]
        );

        setRows(sortedData);
      } catch (error) {
        console.error("Error fetching properties:", error);
      }
    };

    const getLegalTeam = async () => {
      try {
        const response = await investorApi.getLegalTeam();
        setLegalTeam(response.data);
       
      } catch (error) {
        console.error("Error fetching legal team:", error);
      }
    };

    getProperties();
    getLegalTeam();
  }, []);

  const handleAction = (action, row) => {
    if (!row || !row.PropertyName) return;

    const routeMap = {
      approve: "/property/approveProperty",
    };

    if (routeMap[action]) {
      navigate(`${routeMap[action]}?propertyId=${row.id}`, {
        state: { ...row },
      });
    }
  };

  const handleFilterChange = (event) => {
    setStatusFilter(event.target.value);
  };

  const openAssignModal = (row) => {
    setSelectedProperty(row);
    setSelectedTeamMember("");
    setAssignModalOpen(true);
  };

  const closeAssignModal = () => {
    setAssignModalOpen(false);
    setSelectedProperty(null);
  };

  const assignLegalTeam = async () => {
    
    if (!selectedProperty || !selectedTeamMember) return;

    try {
       const response1=await vendorApi.addPropertyApproval( {
        propertyId: selectedProperty.id,
        userId: selectedTeamMember,
      });

      alert("Assigned successfully!");
      closeAssignModal();
    } catch (error) {
      console.error("Error assigning legal team:", error);
      alert("Assignment failed.");
    }
  };

  const filteredData =
    statusFilter === "All"
      ? rows
      : rows.filter((row) => row.Status === statusFilter);

  const getStatusColor = (status) => {
    switch (status) {
      case "Pending":
        return "blue";
      case "Approved":
        return "green";
      case "InProgress":
        return "orange";
      case "Sold":
        return "red";
      default:
        return "gray";
    }
  };

  const columns = [
    { field: "id", headerName: "PropertyID", width: 50 },
    { field: "UserName", headerName: "Vendor Name", width:200 },
    {field:"ProjectName",headerName:"ProjectName",width:200},
    {
      field: "PropertyName",
      headerName: "Property Name",
      width:200,
      renderCell: (params) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => handleAction("approve", params.row)}
        >
          {params.value}
        </span>
      ),
    },
    { field: "City", headerName: "City", width:200 },
    { field: "PropertyPrice", headerName: "Property Value", width:200 },
    { field: "Address", headerName: "Address", width:200 },
    { field: "SizeInSqFt", headerName: "Size (SqFt)", width:200 },
    { field: "SqFtPrice", headerName: "SqFt Price", width:200 },
    {
      field: "Status",
      headerName: "Status",
      width:150,
      renderCell: (params) => (
        <span
          style={{
            color: getStatusColor(params.value),
            fontWeight: "bold",
            textTransform: "capitalize",
          }}
        >
          {params.value}
        </span>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      width:200,
      renderCell: (params) => (
        <Box sx={{ display: "flex", gap: 1 }}>
          {params.row.Status === "Pending" && (
            <>
              <Button
                variant="contained"
                sx={{ backgroundColor: "#4CAF50", color: "white" }}
                onClick={() => handleAction("approve", params.row)}
              >
                Approve
              </Button>
              <Button
                variant="contained"
                sx={{ backgroundColor: "#9C27B0", color: "white" }}
                onClick={() => openAssignModal(params.row)}
              >
                Assign
              </Button>
            </>
          )}
    
          {params.row.Status !== "Pending" && (
            <Button
              variant="contained"
              sx={{ backgroundColor: "#2196F3", color: "white" }}
              onClick={() => handleAction("approve", params.row)} 
            >
              Details
            </Button>
          )}
        </Box>
      ),
    },
    
    
  ];

  return (
    <Box sx={{ mt: 4, px: 2, overflowX: "hidden" }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={8}>
          <h1>Property List</h1>
        </Grid>
        <Grid item xs={4} sx={{ textAlign: "right" }}>
          <FormControl variant="outlined" sx={{ minWidth: 150 }}>
            <InputLabel>Status</InputLabel>
            <Select value={statusFilter} onChange={handleFilterChange} label="Status">
              <MenuItem value="All">All</MenuItem>
              <MenuItem value="Pending">Pending</MenuItem>
              <MenuItem value="Approved">Approved</MenuItem>
              <MenuItem value="Inprogress">Inprogress</MenuItem>
              <MenuItem value="Sold">Sold</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      <Box sx={{  height: 500 ,width:"160vh"}}>
 
    <DataGrid
      rows={filteredData}
      columns={columns}
      pageSize={5}
      rowsPerPageOptions={[5, 10, 25]}
      disableSelectionOnClick
      autoHeight={false}
      sx={{ border: '1px solid #ccc' }}
    />

</Box>







      {/* Assign Modal */}
      <Dialog 
  open={assignModalOpen} 
  onClose={closeAssignModal}
  PaperProps={{
    sx: {
      borderRadius: 3,
      p: 3,
      width: "50%", 
      maxWidth: '90%',
      backgroundColor: '#ffff',
    }
  }}
>
  <DialogTitle sx={{ fontWeight: 'bold', fontSize: '1.25rem', mb: 1 }}>
    Assign <span style={{ color: '#1976d2' }}>{selectedProperty?.PropertyName}</span> for Approval
  </DialogTitle>

  <DialogContent>
    <Typography variant="body1" sx={{ mb: 2 }}>
      <strong>Select Legal Team Member</strong>
    </Typography>

    <FormControl fullWidth sx={{ mt: 1 }}>
      <InputLabel>Legal Team Member</InputLabel>
      <Select
        value={selectedTeamMember}
        onChange={(e) => setSelectedTeamMember(e.target.value)}
        label="Legal Team Member"
        sx={{ borderRadius: 2, backgroundColor: '#fff' }}
      >
        {Array.isArray(legalTeam) &&
          legalTeam.map((member) => (
            <MenuItem key={member.id} value={member.id}>
              {member.name}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  </DialogContent>

  <DialogActions sx={{ mt: 2, justifyContent: 'flex-end' }}>
    <Button onClick={closeAssignModal} sx={{ color: '#666' }}>
      Cancel
    </Button>
    <Button
      variant="contained"
      onClick={assignLegalTeam}
      disabled={!selectedTeamMember}
      sx={{ backgroundColor: '#1976d2', ':hover': { backgroundColor: '#115293' } }}
    >
      Assign
    </Button>
  </DialogActions>
</Dialog>

    </Box>
  );
};

export default PropertyGrid;
